import angular from 'angular';
import '../shared.module';
import { httpFailure } from '../helpers/http-error.helper';

const FILENAME_PATTERN = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i;

export function filenameFromDisposition(header, fallback) {
  const match = FILENAME_PATTERN.exec(header || '');
  return match ? decodeURIComponent(match[1]) : fallback;
}

class DownloadService {
  constructor($http, $q, $window, $document) {
    this.$http = $http;
    this.$q = $q;
    this.$window = $window;
    this.$document = $document;
  }

  fetchBlob(url, params, fallbackMessage = 'Falha ao baixar o arquivo.') {
    return this.$http.get(url, { params, responseType: 'blob' }).then(
      (response) => response,
      (response) => this.$q.reject(httpFailure(response, fallbackMessage))
    );
  }

  objectUrl(url, params) {
    return this.fetchBlob(url, params).then((response) =>
      this.$window.URL.createObjectURL(response.data)
    );
  }

  download(url, params, fallbackName) {
    return this.fetchBlob(url, params, 'Falha ao gerar o arquivo de exportação.').then(
      (response) => {
        const filename = filenameFromDisposition(
          response.headers('Content-Disposition'),
          fallbackName
        );
        this.saveBlob(response.data, filename);
        return { filename, size: response.data.size };
      }
    );
  }

  saveBlob(blob, filename) {
    const objectUrl = this.$window.URL.createObjectURL(blob);
    const anchor = this.$document[0].createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    anchor.rel = 'noopener';
    this.$document[0].body.appendChild(anchor);
    anchor.click();
    this.$document[0].body.removeChild(anchor);
    this.$window.URL.revokeObjectURL(objectUrl);
  }
}

DownloadService.$inject = ['$http', '$q', '$window', '$document'];

angular.module('app.shared').service('DownloadService', DownloadService);

export default DownloadService;
